module.exports = __webpack_public_path__ + "static/media/003-smartphone.2da921ca.svg";